import { lazy } from '@/service/lazy'

export default [{
  name: 'Esqueci Senha',
  path: 'esqueci-senha',
  component: lazy('app/auth/login/esqueci-senha')
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/esqueci-senha.js